import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import useStyles from './styles';
import React, { useEffect, useState } from 'react';
import { Tabs, Tab } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { BackdropLoader } from '@livable/saas-react-components';
import { SubscriptionsTab } from './SubscriptionsTab';
import { useStore } from 'src/stores';
import { PpricingsTab } from './PpricingsTab';
const tabs = [{
  label: 'Subscriptions',
  name: 'subscriptions'
}, {
  label: 'Pricings',
  name: 'pricings'
}];
export const ProPricingPage = observer(() => {
  const classes = useStyles();
  const store = useStore();
  const _useState = useState('subscriptions'),
    _useState2 = _slicedToArray(_useState, 2),
    selectedTab = _useState2[0],
    setSelectedTab = _useState2[1];
  const handleTabChange = (e, newValue) => {
    if (newValue) setSelectedTab(newValue);
  };
  const loadPage = async () => {
    await store.stripe.getMeterAsync.run();
    await store.stripe.getPricesAsync.run();
    await store.stripe.getAllProductsAsync.run();
    await store.stripe.getPriceDashboardAsync.run();
  };
  useEffect(() => {
    try {
      loadPage();
    } catch (e) {
      console.log('useEffect Error', e);
    }
    return () => {
      var _store$stripe$resetSu, _store$stripe;
      (_store$stripe$resetSu = (_store$stripe = store.stripe).resetSubscriptionsListLoaded) === null || _store$stripe$resetSu === void 0 || _store$stripe$resetSu.call(_store$stripe);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const isLoading = store.stripe.getMeterAsync.inProgress || store.stripe.getPricesAsync.inProgress || store.stripe.getAllProductsAsync.inProgress || store.stripe.getPriceDashboardAsync.inProgress;
  return /*#__PURE__*/React.createElement("div", {
    className: classes.pageWrapper
  }, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement("div", {
    className: classes.headerWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.headerTabs
  }, /*#__PURE__*/React.createElement(Tabs, {
    "aria-label": "tabs",
    onChange: handleTabChange,
    value: selectedTab
  }, tabs.map(tab => /*#__PURE__*/React.createElement(Tab, {
    key: tab.name,
    label: tab.label,
    value: tab.name
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.contentWrapper
  }, selectedTab === 'subscriptions' && /*#__PURE__*/React.createElement(SubscriptionsTab, null), selectedTab === 'pricings' && /*#__PURE__*/React.createElement(PpricingsTab, null)));
});